import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectorComponent } from './sector/sector.component';
import { SectorInfoComponent } from './sector-info/sector-info.component';
import { DepartmentInfoComponent } from './department-info/department-info.component';
import { SectorsComponent } from './sectors.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BnsightsLibraryModule } from 'bnsights-control-library';
import { BlockUIModule } from 'ng-block-ui';
import { AuthModule } from '../core/auth.module';
import { SectorsRoutingModule } from './sectors-routing.module';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatMenuModule } from '@angular/material/menu';
import { InlineSVGModule } from 'ng-inline-svg';
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bnsights-utilities-library';
import { DataSecretService } from '../shared/Services/data.service';
import { SectorService } from '../shared/Services/SectorService.service';

@NgModule({
  declarations: [SectorsComponent, SectorComponent, SectorInfoComponent, DepartmentInfoComponent],
  imports: [
    SectorsRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BnsightsLibraryModule,
    NgbModule,
    MatMenuModule,
    InlineSVGModule,
    EmptyDataModule
  ],
  providers:[
    EnvironmentService,
    DataSecretService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    SectorService,
  ]
})
export class SectorsModule { }
